import { useEffect } from "react";

// Lightweight SEO helper — sets title, meta description and OpenGraph tags
// per page without pulling in react-helmet.
export default function Seo({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Bonsai Financial` : "Bonsai Financial";
    document.title = fullTitle;

    const set = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
        if (key && val) el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", fullTitle);
    if (description) set('meta[property="og:description"]', "content", description);
    set('meta[property="og:type"]', "content", "website");

    const origin = window.location.origin;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${origin}${path || window.location.pathname}`);
  }, [title, description, path]);

  return null;
}
